import "./historical-graph.css"

import { Ref, useEffect, useRef } from "react"

import { useCurrentTheme } from "@/theme"

import { useTileCurrencyPair } from "../TileContext"
import { setSize, useHistoricalPath } from "./historicalGraph.state"

interface HistoricalGraphComponentProps {
  path: string
  active?: boolean
  showCenterLine?: boolean
  ref?: Ref<HTMLDivElement>
}

export const HistoricalGraphComponent = ({
  ref,
  path,
  active,
  showCenterLine,
}: HistoricalGraphComponentProps) => {
  const theme = useCurrentTheme()

  return (
    <div className="chart h-[108px] w-[45%] pl-md grid-area-[chart]" ref={ref}>
      <svg className="w-full" data-testid="tile-graph">
        <path
          stroke={
            active
              ? theme.color["Colors/Border/border-buy"]
              : theme.color["Colors/Text/text-primary"]
          }
          strokeOpacity={0.9}
          strokeWidth={1.6}
          fill="none"
          d={path}
        />
        {showCenterLine && (
          <g>
            <line
              y="0"
              strokeDasharray="4 3"
              strokeOpacity="0.9"
              strokeWidth="0.8"
              fill="none"
              fillOpacity="1"
              x1="0"
              y1="40"
              x2={"200"}
              y2="40"
            ></line>
          </g>
        )}
      </svg>
    </div>
  )
}

export const HistoricalGraph = () => {
  const ref = useRef<HTMLDivElement>(null)
  const { symbol } = useTileCurrencyPair()
  useEffect(() => {
    const element = ref.current
    if (!element) return

    const resizeObserver = new ResizeObserver(
      (entries: Array<ResizeObserverEntry>) => {
        const { width, height } = entries[0].contentRect
        setSize(symbol, { width, height })
      },
    )

    resizeObserver.observe(element)

    return () => {
      resizeObserver.unobserve(element)
    }
  }, [symbol])

  const path = useHistoricalPath()

  return path ? <HistoricalGraphComponent ref={ref} path={path} /> : null
}
